import { Component, OnInit, Input } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.css']
})
export class ImageComponent implements OnInit {

  @Input() thumbnailsSize = 15;
  @Input() fileNames = '';
  @Input() height = '300px';
  @Input() images: { small: string, medium: string, big: string }[] = [];

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  displayCaneva: boolean;
  //baseUrlOpenStack = 'http://10.172.10.15:8590/openstack';
  //baseUrlOpenStack = 'https://kaabuv2.orangemali.local:32169/openstack';
  baseUrlOpenStack= 'https://applidistri.orangemali.com:32111/commandes'
  constructor() { }

  ngOnInit() {
    this.galleryOptions = [
      {
        width: '100%',
        height: this.height,
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        imageInfinityMove: true,
        imageAutoPlay: true,
        imageAutoPlayInterval: 9000,
        imageAutoPlayPauseOnHover: true,
        thumbnailsPercent: this.thumbnailsSize,
        thumbnailsMargin: 5,
        thumbnailMargin: 10,
        previewCloseOnClick: false,
        previewInfinityMove: true,
        previewZoom: true,
        previewRotate: true,
        //imageActions: [{icon:'', titleText:'test', (onClick):{e -> {}} }],
        previewZoomMax: 5
      }
    ];
    this.displayCaneva = false;
    this.galleryImages = [];
    this.addFileNames(this.fileNames);
  }

  addFileNames(names: string) {
    console.log('>>>addFileNames:::' + names);
    if (names === null || names === undefined) {
      return;
    }
    let images: string[] = names.split(';');
    if (images.length < 1) {
      return;
    }
    console.log('images.size: ', images.length);
    for (var i = 0; i < images.length; i++) {
      if (images[i] !== '') {
        console.log('openstackName ******************: ' , images[i])
        images[i] = this.imageUrlOpenStackKYC(images[i]);
        this.galleryImages.push({ small: images[i], medium: images[i], big: images[i] });
      }
    }
    if (this.galleryImages.length > 0) {
      this.displayCaneva = true;
    }
  }

  clearFileNames() {
    this.displayCaneva = false;
    this.galleryImages = [];
  }

  imageUrlOpenStackKYC(pieceName: string): string {
    //return this.baseUrlOpenStack + '/afficher?nom-image=' + pieceName + '&container=kyc_container&type-fichier=image';
    return this.baseUrlOpenStack + '/image?image=' + pieceName;
    // return "http://10.172.19.61:32240/openstack/afficher?nom-image=test_image.jpg&container=kyc_container&type-fichier=image"
  }

  // get images() {
  //   return this.imagesName.map(it => {
  //     const e = this.imageUrlOpenStackKYC(it);
  //     return { small: e, medium: e, big: e };
  //   });
  // }
}


